export default __webpack_public_path__ + "static/media/img-proj-finedae.8fa95b12.png";